import { useEffect, useState } from 'react';

const STORAGE_KEY = 'mp-halloween-deadline';
const INITIAL_MS = (23 * 3600 + 49 * 60 + 1) * 1000;

function getDeadline(): number {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    const parsed = stored ? Number(stored) : NaN;
    if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;
    const next = Date.now() + INITIAL_MS;
    window.localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  } catch {
    return Date.now() + INITIAL_MS;
  }
}

export function useCountdown() {
  const [deadline] = useState<number>(getDeadline);
  const [now, setNow] = useState<number>(Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const remaining = Math.max(0, deadline - now);
  const total = Math.floor(remaining / 1000);
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}
